"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPubSub = void 0;
// const PubSub = require('PubSub').default;
const PubSub_1 = __importDefault(require("PubSub"));
exports.AppPubSub = new PubSub_1.default();
